// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { createErrorAnalytics } from '@atlassian/jira-polaris-lib-errors/src/controllers/index.tsx';
import { UnknownError } from '@atlassian/jira-polaris-lib-errors/src/common/utils/unknown-error/index.tsx';
import { logSafeErrorWithoutCustomerDataWrapper } from '@atlassian/jira-polaris-lib-errors/src/common/utils/index.tsx';
import type { QuickstartUiStatus } from '../../../services/constants.tsx';
import type { State } from '../../../services/model/types.tsx';
import { performSaveQuickstartBannerVisibility } from '../../../services/save-quickstart-banner-visibility/save-quickstart-banner-visibility.tsx';

export const setQuickstartBannerVisibility =
	({
		visibility,
		accountId,
	}: {
		visibility: QuickstartUiStatus;
		accountId: AccountId | null;
	}): Action<State> =>
	async ({ getState, setState }) => {
		const { visibility: stateVisibility } = getState();

		if (!accountId || visibility === stateVisibility) {
			return;
		}

		const previousVisibility = stateVisibility;

		try {
			setState({ visibility });

			await performSaveQuickstartBannerVisibility(accountId, visibility);
		} catch (error) {
			const unknownErrorText = `Failed to set quickstart banner visibility with account id: ${accountId} and visibility: ${visibility.description}`;

			fireErrorAnalytics(
				createErrorAnalytics(
					'polaris.error.setQuickstartBannerVisibilityFailed',
					error instanceof Error ? error : new UnknownError(unknownErrorText, error),
				),
			);

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.error.controllers.quickstart-banner.setQuickstartBannerVisibility',
				'Failed to set quickstart banner visibility',
				error instanceof Error ? error : new UnknownError(unknownErrorText, error),
			);

			setState({ visibility: previousVisibility });
		}
	};
